"use client";

import {
  BrowserTabs,
  BrowserTabsList,
  BrowserTab,
  BrowserTabContent,
} from "@workspace/ui/components";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Script from "next/script";
import { VideoPlayer } from "./video-player";

export const Trailer = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState("explainer");

  const scrollToCenter = () => {
    containerRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  useEffect(() => {
    const openDemoTab = () => {
      setActiveTab("demo");
      scrollToCenter();
    };

    if (window.location.hash === "#demo") {
      setActiveTab("demo");
      scrollToCenter();
    } else if (window.location.hash === "#explainer") {
      setActiveTab("explainer");
      scrollToCenter();
    }

    window.addEventListener("open-demo-tab", openDemoTab);

    return () => {
      window.removeEventListener("open-demo-tab", openDemoTab);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative flex justify-center w-full overflow-x-hidden px-5"
      id="demo"
    >
      <div className="absolute z-[-1] w-[200%] 2xl:w-full top-1/2 left-1/2 -translate-1/2 flex items-center">
        <Image
          src="/landing/dots.png"
          width={1504}
          height={328}
          alt="dots"
          className="object-cover w-1/2 h-full"
        />
        <Image
          src="/landing/dots.png"
          width={1504}
          height={328}
          alt="dots"
          className="object-cover w-1/2 h-full"
        />
      </div>
      <BrowserTabs
        value={activeTab}
        onValueChange={(value) => setActiveTab(value)}
      >
        <BrowserTabsList>
          <BrowserTab
            value="explainer"
            href="#explainer"
            className="whitespace-nowrap"
          >
            Yolk Explainer
          </BrowserTab>
          <BrowserTab value="demo" href="#demo" className="whitespace-nowrap">
            Interactive Demo
          </BrowserTab>
        </BrowserTabsList>
        <BrowserTabContent value="demo">
          <div className="w-full h-full">
            <Script
              async
              src="https://js.storylane.io/js/v2/storylane.js"
              strategy="lazyOnload"
            />
            <div className="sl-embed w-full h-full">
              <iframe
                loading="lazy"
                className="sl-demo"
                src="https://yolk.storylane.io/demo/g37xxqtvhdjq?embed=inline"
                name="sl-embed"
                allow="fullscreen"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "1px solid rgba(63,95,172,0.35)",
                  boxShadow: "0px 0px 18px rgba(26, 19, 72, 0.15)",
                  borderRadius: "10px",
                  boxSizing: "border-box",
                }}
              />
            </div>
          </div>
        </BrowserTabContent>
        <BrowserTabContent value="explainer">
          <VideoPlayer isActive={activeTab === "explainer"} />
        </BrowserTabContent>
      </BrowserTabs>
    </div>
  );
};
